import { GradientToken } from "./SDKGradientToken";
import { ShadowToken } from "./SDKShadowToken";
export const getReferencedTokens = (token, allTokens) => {
    if (token instanceof ShadowToken || token instanceof GradientToken) {
        // TODO:fix-sdk-eslint
        // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        return token.value.map((v) => allTokens.get(v.referencedTokenId));
    }
    if (token.value.referencedTokenId) {
        return [allTokens.get(token.value.referencedTokenId)];
    }
    return [];
};
export const getSingleReferencedTokenId = (token, allTokens) => {
    const refs = getReferencedTokens(token, allTokens);
    if (refs.length !== 1 || !refs[0]) {
        return undefined;
    }
    return refs[0].id;
};
export const checkSingleReferencedTokenById = (token, candidateId, allTokens) => {
    return (candidateId && getSingleReferencedTokenId(token, allTokens) === candidateId);
};
export const replaceReferencedTokenIds = (token, currentId, newId, allTokens) => {
    for (const t of getReferencedTokens(token, allTokens)) {
        if (t && t.id === currentId) {
            t.id = newId;
        }
    }
};
export const replaceReferencedToken = (token, existingToken, newToken) => {
    replaceReferencedTokenByIds(token, existingToken.id, newToken.id);
    replaceOriginReferencePersistentIdByIds(token, existingToken.id, newToken.id);
};
export const replaceReferencedTokenByIds = (token, existingTokenId, newTokenId) => {
    const value = token === null || token === void 0 ? void 0 : token.value;
    if (!value) {
        // Do nothing if there is no value
    }
    else if (!Array.isArray(value)) {
        if ((value === null || value === void 0 ? void 0 : value.referencedTokenId) === existingTokenId) {
            value.referencedTokenId = newTokenId;
        }
    }
    else {
        for (const item of value) {
            // FIXME: Deep layers
            if ((item === null || item === void 0 ? void 0 : item.referencedTokenId) === existingTokenId) {
                item.referencedTokenId = newTokenId;
            }
        }
    }
};
export const replaceOriginReferencePersistentIdByIds = (token, existingTokenId, newTokenId) => {
    const origin = token === null || token === void 0 ? void 0 : token.origin;
    if (!(origin === null || origin === void 0 ? void 0 : origin.referencePersistentId)) {
        // Do nothing if there is no origin
    }
    else if (origin.referencePersistentId &&
        !Array.isArray(origin.referencePersistentId)) {
        if (origin.referencePersistentId === existingTokenId) {
            origin.referencePersistentId = newTokenId;
        }
    }
};
